import { ButtonSpinner } from '../components/ButtonSpinner'
import { InquiryTextField } from '../components/InquiryFields'
import { InquiryFormLayout } from '../components/InquiryFormLayout'
import {
  B2B_REQUIREMENT_OPTIONS,
  CORPORATE_ENQUIRY_COPY,
} from '../constants/inquiries'
import { cx } from '../helpers/format'
import { useCorporateEnquiryForm } from '../hooks/useCorporateEnquiryForm'
import '../styles/inquiry-page.scss'

export function CorporateEnquiryPage() {
  const { form, update, submitting, submitted, error, onSubmit, toggleRequirement } =
    useCorporateEnquiryForm()
  const fields = CORPORATE_ENQUIRY_COPY.fields

  return (
    <InquiryFormLayout
      variant="b2b"
      title={CORPORATE_ENQUIRY_COPY.title}
      lead={CORPORATE_ENQUIRY_COPY.lead}
    >
      {submitted ? (
        <p className="inquiry-success" role="status">
          {CORPORATE_ENQUIRY_COPY.success}
        </p>
      ) : (
        <form className="inquiry-form inquiry-form--sections" onSubmit={onSubmit}>
          <section className="inquiry-section">
            <h3>
              <span>1</span>
              {CORPORATE_ENQUIRY_COPY.sections.details}
            </h3>
            <div className="inquiry-section__grid">
              <InquiryTextField
                id="b2b-name"
                label={fields.name.label}
                placeholder={fields.name.placeholder}
                value={form.name}
                required
                autoComplete="name"
                disabled={submitting}
                onChange={(name) => update({ name })}
              />
              <InquiryTextField
                id="b2b-company"
                label={fields.company.label}
                placeholder={fields.company.placeholder}
                value={form.company}
                required
                autoComplete="organization"
                disabled={submitting}
                onChange={(company) => update({ company })}
              />
              <InquiryTextField
                id="b2b-email"
                label={fields.email.label}
                type="email"
                placeholder={fields.email.placeholder}
                value={form.email}
                required
                autoComplete="email"
                disabled={submitting}
                onChange={(email) => update({ email })}
              />
              <InquiryTextField
                id="b2b-phone"
                label={fields.phone.label}
                type="tel"
                placeholder={fields.phone.placeholder}
                value={form.phone}
                required
                autoComplete="tel"
                disabled={submitting}
                onChange={(phone) => update({ phone })}
              />
            </div>
          </section>

          <section className="inquiry-section">
            <h3>
              <span>2</span>
              {CORPORATE_ENQUIRY_COPY.sections.requirement}
            </h3>
            <div className="inquiry-tiles" role="group" aria-label={CORPORATE_ENQUIRY_COPY.sections.requirement}>
              {B2B_REQUIREMENT_OPTIONS.map((option) => {
                const selected = form.requirements.includes(option.id)
                return (
                  <button
                    key={option.id}
                    type="button"
                    className={cx('inquiry-tile', selected && 'is-selected')}
                    aria-pressed={selected}
                    disabled={submitting}
                    onClick={() => toggleRequirement(option.id)}
                  >
                    {option.label}
                  </button>
                )
              })}
            </div>
            <div className="inquiry-field inquiry-field--wide">
              <label htmlFor="b2b-description">
                {fields.description.label}
                <span aria-hidden="true"> *</span>
              </label>
              <textarea
                id="b2b-description"
                placeholder={fields.description.placeholder}
                value={form.description}
                required
                disabled={submitting}
                rows={4}
                onChange={(event) => update({ description: event.target.value })}
              />
            </div>
          </section>

          <section className="inquiry-section">
            <h3>
              <span>3</span>
              {CORPORATE_ENQUIRY_COPY.sections.delivery}
            </h3>
            <div className="inquiry-section__grid">
              <InquiryTextField
                id="b2b-city"
                label={fields.deliveryCity.label}
                placeholder={fields.deliveryCity.placeholder}
                value={form.deliveryCity}
                required
                disabled={submitting}
                onChange={(deliveryCity) => update({ deliveryCity })}
              />
              <InquiryTextField
                id="b2b-date"
                label={fields.preferredDate.label}
                type="date"
                value={form.preferredDate}
                disabled={submitting}
                onChange={(preferredDate) => update({ preferredDate })}
              />
              <InquiryTextField
                id="b2b-quantity"
                label={fields.quantity.label}
                placeholder={fields.quantity.placeholder}
                value={form.quantity}
                disabled={submitting}
                onChange={(quantity) => update({ quantity })}
              />
              <InquiryTextField
                id="b2b-budget"
                label={fields.budget.label}
                placeholder={fields.budget.placeholder}
                value={form.budget}
                disabled={submitting}
                onChange={(budget) => update({ budget })}
              />
            </div>
            <div className="inquiry-form__footer">
              <label className="inquiry-check">
                <input
                  type="checkbox"
                  checked={form.gstInvoice}
                  disabled={submitting}
                  onChange={(event) => update({ gstInvoice: event.target.checked })}
                />
                {fields.gstInvoice}
              </label>
              <button type="submit" className="inquiry-submit" disabled={submitting}>
                {submitting ? (
                  <ButtonSpinner label={CORPORATE_ENQUIRY_COPY.submit} />
                ) : (
                  CORPORATE_ENQUIRY_COPY.submit
                )}
              </button>
            </div>
          </section>

          {error ? (
            <p className="inquiry-error" role="alert">
              {error}
            </p>
          ) : null}
          <p className="inquiry-privacy">{CORPORATE_ENQUIRY_COPY.privacy}</p>
        </form>
      )}
    </InquiryFormLayout>
  )
}
